import { RelationalActionParameter } from "./RelationalActionParameter";
import { IPasteApplicable } from "./IPasteApplicable";
import { IItem } from "./IItem";

export interface IPasteRequestable extends IItem {
  pasteDestinations: RelationalActionParameter[];
  pasteTo(item: IPasteApplicable): void;
  isValueUpdated(oldItem: IItem): boolean;
}

export function instanceOfIPasteRequestable(instance: any): instance is IPasteRequestable {
  if (!instance) { return false; }
  return (instance.pasteDestinations !== undefined)
    && (instance.pasteTo !== undefined)
    && (instance.isValueUpdated !== undefined);
}
